// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ProjectPermissionSchema = z.object({
  project_id: z.number().int().describe("Project ID"),
  user_id: z.number().int().describe("User ID"),
  hour_rate: z.number().describe("Hourly rate for this user on this project"),
  hour_rate_in_cents: z.number().describe("Hourly rate in cents"),
  rate_type: z.coerce.string().describe("Rate type (e.g., project, user)"),
  updated_at: z.number().int().describe("Last updated timestamp (Unix epoch)"),
  created_at: z.number().int().describe("Creation timestamp (Unix epoch)"),
  deleted: z.boolean().describe("Whether the project permission is deleted"),
  logged_at: z.number().int().describe("Last logged timestamp (Unix epoch)"),
});
